export const baseUrl = '/dashboard'
export const baseBannerUrl = '/banners'
